// Add bibram if it exist and remove protocol
export const formatDomainUrl = (domainUrl: string, bigram?: string) =>
  `${domainUrl}${bigram ? `/${bigram}` : ''}`.replace(/(^\w+:|^)\/\//, '');
